import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { ShouldLoginComponent } from './core/components/should-login/should-login.component';
import { CanForceLogoutGuard } from './core/guards/can-force-logout.guard';
import { ForceClaimChangeComponent } from './layout/main/force-claim-change/force-claim-change.component';
import { ForceLogoutComponent } from './layout/main/force-logout/force-logout.component';

const routes: Routes = [
  {
    path: '404',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   redirectTo: 'home',
  // },
  {
    path: '',
    loadChildren: () =>
      import('./layout/main/main.module').then((m) => m.MainModule),
  },
  {
    path: 'should-login',
    component: ShouldLoginComponent,
  },
  {
    canDeactivate: [CanForceLogoutGuard],
    path: 'force-logout',
    component: ForceLogoutComponent,
  },
  {
    path: 'force-claim-change',
    component: ForceClaimChangeComponent,
  },
  // {
  //   path: 'home',
  //   component: MainHomeComponent,
  //   canActivate: [CheckRedirectHome, AuthForceLoginGuard],
  // },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/login/login.module').then((m) => m.LoginModule),
  },
  { path: 'e-invoice', loadChildren: () => import('./features/e-invoice/e-invoice.module').then(m => m.EInvoiceModule) },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
